<section [class.w-full]="expand()" class="flex gap-3 items-center">
  @for (option of options(); track $index) {
    <app-segment-tab
      [expand]="expand()"
      [class.w-full]="expand()"
      (click)="value.set(option.value)"
      [label]="option.label"
      [value]="option.value"
      [count]="option.count"
      [icon]="option.icon || ''"
      [active]="value() === option.value"
    />
  }
</section>
